import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { IconThemeReverseModule } from '../../../../shared';
import { CatalogFilterResetComponent } from './catalog-filter-reset.component';

@NgModule({
  declarations: [CatalogFilterResetComponent],
  exports: [CatalogFilterResetComponent],
  imports: [CommonModule, NzIconModule, I18nModule, IconThemeReverseModule],
})
export class CatalogFilterResetModule {}
